import React from "react";
import { Link } from "react-router-dom";

const HomeBox = ({
  icon,
  title,
  subtitle,
  link,
  to,
  cta = "Vai",
  disabled = false,
  unpaidCount = 0,
  receivedUnpaidCount = 0,
}) => {
  const href = to || link || "#";
  const isAppBox = String(href || "").startsWith("/app/");

  const CardInner = isAppBox ? (
    <div
      className={`h-100 shadow-sm ${disabled ? "opacity-50" : ""}`}
      style={{
        borderRadius: 28,
        background: "linear-gradient(135deg, #ffffff 0%, #fff8f1 100%)",
        border: "1px solid rgba(91,15,27,0.10)",
        overflow: "hidden"
      }}
    >
      <div className="p-3 d-flex align-items-center gap-3 text-start">
        <div
          className="d-flex align-items-center justify-content-center flex-shrink-0"
          style={{
            width: 58,
            height: 58,
            borderRadius: 20,
            background: "linear-gradient(135deg, #5b0f1b 0%, #8b1e2d 100%)",
            color: "#fff",
            fontSize: 28,
            boxShadow: "0 10px 22px rgba(91,15,27,0.18)"
          }}
        >
          {icon}
        </div>

        <div className="flex-grow-1">
          <div className="fw-bold" style={{ fontSize: 19, color: "#211014" }}>
            {title}
          </div>
          {subtitle && (
            <div className="small" style={{ color: "rgba(33,16,20,0.62)", lineHeight: 1.25 }}>
              {subtitle}
            </div>
          )}
        </div>

        {!disabled ? (
          <div
            className="d-flex align-items-center justify-content-center flex-shrink-0"
            style={{
              width: 38,
              height: 38,
              borderRadius: 999,
              background: "rgba(91,15,27,0.09)",
              color: "#5b0f1b",
              fontWeight: 800,
              fontSize: 22
            }}
          >
            ›
          </div>
        ) : (
          <span className="badge bg-secondary">No</span>
        )}
      </div>

      {(Number(unpaidCount || 0) > 0 || Number(receivedUnpaidCount || 0) > 0) && (
        <div className="px-3 pb-3">
          {Number(unpaidCount || 0) > 0 && (
            <span className="badge bg-danger me-2">{unpaidCount} da incassare</span>
          )}
          {Number(receivedUnpaidCount || 0) > 0 && (
            <span className="badge bg-warning text-dark">{receivedUnpaidCount} da pagare</span>
          )}
        </div>
      )}
    </div>
  ) : (
    <div className={`card h-100 text-center shadow-sm ${disabled ? "opacity-50" : ""}`}>
      <div className="card-body">
        <div className="fs-2 mb-2">{icon}</div>
        <h5 className="mb-1">{title}</h5>
        {subtitle && <p className="text-muted mb-3">{subtitle}</p>}

        {!disabled ? (
          <>
            <div>
              <span className="btn btn-outline-primary">{cta}</span>
            </div>

            {Number(unpaidCount || 0) > 0 && (
              <div className="mt-2">
                <span className="badge bg-danger">{unpaidCount} da incassare</span>
              </div>
            )}

            {Number(receivedUnpaidCount || 0) > 0 && (
              <div className="mt-2">
                <span className="badge bg-warning text-dark">{receivedUnpaidCount} da pagare</span>
              </div>
            )}
          </>
        ) : (
          <span className="btn btn-secondary disabled">Non disponibile</span>
        )}
      </div>
    </div>
  );

  return (
    <div className="col-sm-6 col-md-4 col-lg-3 mb-4">
      {disabled ? (
        CardInner
      ) : (
        <Link to={href} className="text-decoration-none">
          {CardInner}
        </Link>
      )}
    </div>
  );
};

export default HomeBox;
